export default (mountAutoComplete) =>
  mountAutoComplete({
    cocoonSelector: `[data-behaviour="companies-not-in-group-list"]`,
    path: (element) =>
      Silverfin.Routes.unassigned_companies_group_path(
        Silverfin.currentFirmId,
        element.dataset.groupId
      ),
    textfieldSelector: '[data-behaviour="groups-company-autocomplete"]',
  })
